import { MasterIndirectTaskService } from '@amzn/ihm-associate-tools-js-lib'
import { resetIdlePrompt, setIdlePrompt, setMI } from '@atredux/slices/atAlertSlice'
import { store } from '@atredux/store'
import { _navigateToTool } from '@src/components/SideBar/utils/SideBarUtil'
import { seawardReactTool, seawardTool } from '@services/ToolMenuConfigService'

export const DEFAULT_IDLE_TIME = 10 * 60 * 1000
export const DEFAULT_TOT_TIME = 25 * 60 * 1000
export const TIME_OFF_TASK = 'Idle time task'

const IFRAME_CLASS_NAME = 'iframe-container'

export class IdleTimeService {
    private static _instance: IdleTimeService
    private promptThreshold: number
    private totThreshold: number
    private promptTimeout: NodeJS.Timeout
    private totTimeout: NodeJS.Timeout
    private isIdleDisabled: boolean

    public static getInstance = (): IdleTimeService => {
        if (!IdleTimeService._instance) {
            IdleTimeService._instance = new IdleTimeService()
        }

        return IdleTimeService._instance
    }

    public constructor (promptThreshold?: number, totThreshold?: number) {
        this.promptThreshold = promptThreshold ? promptThreshold : DEFAULT_IDLE_TIME
        this.totThreshold = totThreshold ? totThreshold : DEFAULT_TOT_TIME
        this.isIdleDisabled = false
    }

    public init = (promptThreshold?: number, totThreshold?: number) => {
        this.promptThreshold = promptThreshold ? promptThreshold : DEFAULT_IDLE_TIME
        this.totThreshold = totThreshold ? totThreshold : DEFAULT_TOT_TIME

        const selectedTool = store.getState().tool.tool

        this.disablePrompt()

        if (!selectedTool.showMigrated) {
            console.log('ATBase: Not initlializing idle time for non-migrated tool.')
            clearTimeout(this.totTimeout)
            return
        }

        console.log('ATBase: Idle time initialized with parameters: ', this.promptThreshold, this.totThreshold)

        const prompt = () => {
            if (MasterIndirectTaskService.getInstance().getMITask() === TIME_OFF_TASK) {
                store.dispatch(resetIdlePrompt())
                store.dispatch(setMI())
                return
            }
            store.dispatch(setIdlePrompt())
        }

        const tot = () => {
            if (this.isIdleDisabled) {
                _navigateToTool(seawardReactTool)
            }
            MasterIndirectTaskService.getInstance().setToT()
        }

        const resetTimer = () => {
            clearTimeout(this.promptTimeout)
            clearTimeout(this.totTimeout)
            if (!this.isIdleDisabled) {
                this.promptTimeout = setTimeout(prompt, this.promptThreshold)
            }
            this.totTimeout = setTimeout(tot, this.totThreshold)
        }

        resetTimer()
        window.onload = resetTimer

        const iframeContainer = document.getElementsByClassName(IFRAME_CLASS_NAME)[0]
        const migratedFrame = (iframeContainer.children[0] as any).contentWindow

        // DOM Events
        document.onkeydown = resetTimer
        document.onmousemove = resetTimer
        document.ontouchend = resetTimer
        if (selectedTool !== seawardReactTool && selectedTool !== seawardTool) {
            migratedFrame.onkeydown = resetTimer
            migratedFrame.onmousemove = resetTimer
            migratedFrame.ontouchend = resetTimer
        }
    }

    public disablePrompt = () => {
        const resetTimer = () => {}

        clearTimeout(this.promptTimeout)

        // DOM Events
        document.onkeydown = resetTimer
        document.onmousemove = resetTimer
        document.ontouchend = resetTimer
    }

    public setPromptThreshold = (promptThreshold: number) => {
        this.promptThreshold = promptThreshold
    }

    public setToTThreshold = (totThreshold: number) => {
        this.totThreshold = totThreshold
    }

    public setIdleDisabled = (idleDisabled: boolean) => {
        this.isIdleDisabled = idleDisabled
    }
}
